import React from 'react';
import { FacebookIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-base relative pt-1" data-id="element-144">
      {/* Animated Gradient Border Top */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-neon-purple via-electric-blue to-neon-green bg-[length:200%_auto] animate-[aurora_5s_linear_infinite]" data-id="element-145" />

      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-146">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8" data-id="element-147">
          <div className="text-2xl font-heading font-bold tracking-tight text-white" data-id="element-148">
            Euro Rastpark <span className="text-white/40" data-id="element-149">Himmelkron</span>
          </div>

          <div className="flex gap-4" data-id="element-150">
            <a href="#" className="w-10 h-10 rounded-full glass-card flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition-all" data-id="element-151">
              <FacebookIcon className="w-5 h-5" data-id="element-152" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full glass-card flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition-all" data-id="element-153">
              <InstagramIcon className="w-5 h-5" data-id="element-154" />
            </a>
          </div>
        </div>

        <div className="h-px w-full bg-white/5 mb-8" data-id="element-155" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/40" data-id="element-156">
          <p data-id="element-157">© 2026 Euro Rastpark Himmelkron. Alle Rechte vorbehalten.</p>
          <div className="flex gap-6" data-id="element-158">
            <a href="#" className="hover:text-white transition-colors" data-id="element-159">
              Impressum
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-160">
              Datenschutz
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-161">
              Standorte
            </a>
          </div>
        </div>
      </div>
    </footer>;
}